import * as React from 'react';

import classnames from 'classnames';

import { P1 } from 'components/typography';

type Props = {
  tag?: 'div' | 'section';
  list?: {
    text: string;
    id: string;
  }[];
};

const SectionContentLinkList: React.FunctionComponent<Props> = ({ tag = 'div', list }) => {
  const className = {
    block: classnames({
      'section-content-link-list': true,
    }),
    items: classnames({
      'section-content-link-list__items': true,
    }),
    item: classnames({
      'section-content-link-list__item': true,
    }),
    link: classnames({
      'section-content-link-list__item-link': true,
    }),
  };

  const Tag = tag as React.ElementType;

  return (
    <Tag className={className.block}>
      <ul className={className.items}>
        {list &&
          list.map((listItem, key) => (
            <React.Fragment key={key}>
              <li className={className.item}>
                <a className={className.link} href={`#${listItem.id}`}>
                  <P1 html={listItem.text} as="span" />
                </a>
              </li>
            </React.Fragment>
          ))}
      </ul>
    </Tag>
  );
};

export { SectionContentLinkList };
